export const pontoTipo = {
  INICIO: 0,
  PAUSA: 1,
  FIM: 2,
} as const;

export type PontoTipo = typeof pontoTipo[keyof typeof pontoTipo];
